<form class="form-horizontal">
  <h3>Konfiguration</h3>

  <div class="row">
    <div class="col-md-12">

      @if (('article.production_step_setting'|HasPerm)) {
        <button type="button" class="btn btn-success" (click)="newProductionStep()">
          Neuer Fertigungsschritt
        </button>
      }

    </div>

    <div class="col-md-12">&nbsp;</div>

    <div class="col-md-4">

      <table class="table whitetable">

        <thead>
          <tr>
            <th>Nr</th>
            <th>Bezeichnung</th>
            <th>Dauer</th>
            <th>Min-Dauer</th>
            <th>Max-Dauer</th>
            <th>Wertigkeit</th>
            <th colspan="5">&nbsp;</th>
          </tr>
        </thead>

        <tbody>
          @for (obj of objects; track trackById(index, obj); let index = $index) {
            <tr style="text-align: center; vertical-align: middle;">
              <td>{{ obj.nr }}</td>
              <td>{{ obj.text }}</td>
              <td>{{ obj.duration }} m</td>
              <td>{{obj.min_duration}} m</td>
              <td>{{ obj.max_duration }} m</td>
              <td>{{obj.significance}}</td>
              <td>
                <button type="button" class="ev-button" (click)="stepEdit(index, obj)">
                  <i class="fa fa-2x fa-pencil"></i>
                </button>
              </td>
              <td>
                <button type="button" class="btn btn-default btn-sm m-0!" (click)="editArticle(index, obj)">
                  Artikelfelder
                </button>
              </td>
              <td>
                <button type="button" class="btn btn-default btn-sm m-0!" (click)="editQuestionnaire(obj)">
                  Fragebogen
                </button>
              </td>
              <td>
                <production-step-material [productionStep]="obj"></production-step-material>
              </td>
              <td>
                @if (!obj.active && ('settings.settings'|HasPerm)) {
                  <button type="button" class="ev-button" (click)="toggle(index, obj)"
                    >
                    <i class="fa fa-toggle-off fa-2x"></i>
                  </button>
                }
                @if (obj.active  && ('settings.settings'|HasPerm)) {
                  <button type="button" class="ev-button" (click)="toggle(index, obj)"
                    >
                    <i class="fa fa-toggle-on fa-2x" style="color: green;"></i>
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>

      </table>

    </div>

  </div>

</form>
